@if (showSuccess()) {
  <app-successful-notification type="success" [title]="successTitle" />
}

@if (error()) {
  <div class="my-4">
    <app-error [apiError]="error()" />
  </div>
}

<form [formGroup]="bundleForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
  <div class="flex flex-col gap-6 rounded-2xl bg-white p-6 shadow-sm">
    <h3 class="textTabsColor text-[20px] font-[600]" i18n="@@bundle.info.sectionTitle">Bundle Information</h3>

    <div class="grid grid-cols-2 gap-x-4 gap-y-5">
      <div class="flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]">
          <span i18n="@@bundle.info.titleEn.label">Bundle Name (En)</span>
        </label>
        <input
          type="text"
          formControlName="titleEn"
          placeholder="Enter Bundle Name in English (optional)"
          i18n-placeholder="@@bundle.info.titleEn.placeholder"
          class="borderDefault placeholder:textPlaceholderColor focus:borderTabsColor h-[44px] rounded-[8px] border px-3 py-2 text-[14px] focus:outline-none" />
      </div>

      <div class="flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]">
          <span i18n="@@bundle.info.titleAr.label">Bundle Name (Arabic)</span>
          <span class="textTabsColor ml-1">*</span>
        </label>
        <input
          type="text"
          formControlName="titleAr"
          i18n-placeholder="@@bundle.info.titleAr.placeholder"
          placeholder="Enter Bundle Name in Arabic"
          dir="rtl"
          class="borderDefault placeholder:textPlaceholderColor focus:borderTabsColor h-[44px] rounded-[8px] border px-3 py-2 text-[14px] focus:outline-none" />
        @if (bundleForm.get("titleAr")?.invalid && bundleForm.get("titleAr")?.touched) {
          <span class="textTabsColor text-[12px]">
            @if (bundleForm.get("titleAr")?.errors?.["required"]) {
              <span i18n="@@bundle.info.titleAr.error.required">Arabic name is required</span>
            } @else if (bundleForm.get("titleAr")?.errors?.["minlength"] || bundleForm.get("titleAr")?.errors?.["maxlength"]) {
              <span i18n="@@bundle.info.titleAr.error.range">Arabic name must be between 2 and 150 characters</span>
            } @else if (bundleForm.get("titleAr")?.errors?.["containsEnglish"]) {
              <span i18n="@@bundle.info.titleAr.error.characters">Arabic name cannot contain English letters</span>
            }
          </span>
        }
      </div>

      <div class="col-span-2 flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]" i18n="@@bundle.info.descriptionEn.label">
          Bundle Description (English)
        </label>
        <textarea
          formControlName="descriptionEn"
          rows="4"
          i18n-placeholder="@@bundle.info.descriptionEn.placeholder"
          placeholder="Enter Bundle Description in English"
          class="borderDefault placeholder:textPlaceholderColor focus:borderTabsColor rounded-[8px] border px-3 py-2 text-[14px] focus:outline-none"></textarea>
      </div>

      <div class="col-span-2 flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]" i18n="@@bundle.info.descriptionAr.label">
          Bundle Description (Arabic)
        </label>
        <textarea
          formControlName="descriptionAr"
          rows="4"
          i18n-placeholder="@@bundle.info.descriptionAr.placeholder"
          placeholder="Enter Bundle Description in Arabic"
          dir="rtl"
          class="borderDefault placeholder:textPlaceholderColor focus:borderTabsColor rounded-[8px] border px-3 py-2 text-[14px] focus:outline-none"></textarea>
      </div>

      <div class="flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]">
          <span i18n="@@bundle.info.startDate.label">Start Date</span>
          <span class="textTabsColor ml-1">*</span>
        </label>
        <input
          type="date"
          formControlName="startDate"
          class="borderDefault textPlaceholderColor focus:borderTabsColor h-[44px] cursor-pointer rounded-[8px] border px-3 text-[14px] focus:outline-none" />
      </div>

      <div class="flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]">
          <span i18n="@@bundle.info.endDate.label">End Date</span>
          <span class="textTabsColor ml-1">*</span>
        </label>
        <input
          type="date"
          formControlName="endDate"
          class="borderDefault textPlaceholderColor focus:borderTabsColor h-[44px] cursor-pointer rounded-[8px] border px-3 text-[14px] focus:outline-none" />
      </div>

      <div class="flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]">
          <span i18n="@@bundle.info.discountType.label">Discount Type</span>
          <span class="textTabsColor ml-1">*</span>
        </label>

        <div class="relative">
          <select
            formControlName="discountType"
            class="borderDefault textPlaceholderColor focus:borderTabsColor h-[44px] w-full cursor-pointer appearance-none rounded-[8px] border bg-white px-3 pr-10 text-[14px] focus:outline-none">
            <option value="" disabled selected i18n="@@bundle.info.discountType.placeholder">
              Select Discount Type
            </option>
            <option value="PERCENTAGE" i18n="@@bundle.info.discountType.option.percentage">Percentage</option>
          </select>
        </div>
      </div>

      <div class="flex flex-col gap-1">
        <label class="labelColorText text-[14px] font-[600]">
          <span i18n="@@bundle.info.discountValue.label">Discount Value</span>
          <span class="textTabsColor ml-1">*</span>
        </label>
        <input
          type="number"
          formControlName="discountValue"
          i18n-placeholder="@@bundle.info.discountValue.placeholder"
          placeholder="e.g 40"
          class="borderDefault placeholder:textPlaceholderColor focus:borderTabsColor h-[44px] rounded-[8px] border px-3 text-[14px] focus:outline-none" />
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <label class="textPlaceholderColor text-[14px] font-[600]">
        <span i18n="@@bundle.info.images.label">Bundle Images</span>
        <span class="textTabsColor ml-1">*</span>
      </label>
      <div
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        class="borderDefault flex flex-col items-center justify-center gap-2 rounded-[12px] border-2 border-dashed bg-white py-10">
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="textGray">
          <path
            d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C18.1046 10 19 10.8954 19 12C19 13.1046 18.1046 14 17 14H7C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M12 12V18M12 18L10 16M12 18L14 16"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>

        <p class="textNeutral text-[14px]" i18n="@@bundle.info.images.uploadHint">
          Click to upload or drag and drop
        </p>
        <p class="textGray text-[12px]" i18n="@@bundle.info.images.uploadSubHint">
          Max File Size: 5MB · JPG, JPEG, PNG · Up to 5 images
        </p>

        <button
          type="button"
          (click)="fileInput.click()"
          class="bgTabsColor mt-2 flex cursor-pointer items-center gap-2 rounded-[8px] px-6 py-2 text-[14px] font-[500] text-white">
          <span i18n="@@bundle.info.images.browseBtn">Browse File</span>
        </button>
        <input
          #fileInput
          type="file"
          (change)="onFileSelect($event)"
          multiple
          class="hidden"
          accept="image/png, image/jpeg, image/jpg" />
      </div>
      @if (selectedImages().length > 0) {
        <div class="mt-4 flex flex-wrap gap-3 px-4">
          @for (img of selectedImages(); track $index) {
            <div class="relative h-24 w-24">
              <img [src]="img.preview" class="h-full w-full rounded-[8px] border border-gray-200 object-cover" />
              <button
                type="button"
                (click)="removeSelectedImage($index)"
                class="absolute -top-2 -right-2 flex h-5 w-5 cursor-pointer items-center justify-center rounded-full bg-red-500 text-white hover:bg-red-600">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              @if ($index === 0) {
                <span
                  class="absolute bottom-1 left-1 rounded bg-black/50 px-1 text-[10px] text-white"
                  i18n="@@bundle.info.images.primary">
                  Primary
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="mt-4 flex justify-end gap-4">
    <button
      type="button"
      class="subtleButton borderTabsColor textTabsColor h-[48px] min-w-[140px] cursor-pointer rounded-[10px] border font-[600]"
      i18n="@@bundle.info.btn.cancel">
      Cancel
    </button>

    <button
      type="submit"
      [disabled]="bundleForm.invalid || selectedImages().length === 0 || loading()"
      class="primaryButton cursor-pointer rounded-lg px-10 py-2.5 text-sm font-bold text-white shadow transition disabled:opacity-60">
      @if (loading()) {
        <span i18n="@@bundle.info.btn.saving">Saving...</span>
      } @else {
        <span i18n="@@bundle.info.btn.next">Next</span>
      }
    </button>
  </div>
</form>
